import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';

const experiences = [
  {
    role: 'Open to New Opportunities',
    company: 'Looking for Next Role',
    location: 'Chennai, Tamil Nadu',
    period: 'Jun 2026 – Present',
    type: 'Immediate Joiner',
    description: 'Actively seeking Full Stack or Frontend roles where I can contribute, grow, and build impactful products.',
    responsibilities: [
      'Open to Full Stack, Frontend, or React Native roles',
      'Available for On-site, Hybrid, or Remote opportunities',
      'Open to pan-India locations | Immediate joiner',
    ],
    tags: ['ReactJS', 'React Native', 'ASP.NET Core', 'SQL Server', 'Python', 'Node.js'],
    isOpen: true,
  },
  {
    role: 'Junior Software Developer',
    company: 'Vivify Technocrats',
    location: 'Chennai, Tamil Nadu',
    period: 'Apr 2025 – May 2026',
    type: 'Full-time',
    description: 'Built and shipped 5+ production apps used by 200+ end users across ERP, HRMS, E-Commerce, and Safety domains, reducing client operational effort by 30%.',
    responsibilities: [
      'Shipped 5+ production apps using ReactJS, React Native, ASP.NET Core, and SQL Server',
      'Designed 30+ RESTful APIs with JWT authentication, CRUD operations, and real-time data handling',
      'Implemented Role-Based Access Control (RBAC), eliminating unauthorized access incidents entirely',
      'Optimized SQL Server queries and Entity Framework models, reducing API response time by 25%',
      'Delivered 3 enterprise releases on schedule within an Agile team of 5+',
    ],
    tags: ['ReactJS', 'React Native', 'ASP.NET Core', 'SQL Server', 'Node.js', 'REST APIs', 'RBAC'],
    isOpen: false,
  },
  {
    role: 'Frontend Developer Trainee',
    company: 'Tera Infotech',
    location: 'Tirunelveli, Tamil Nadu',
    period: 'Apr 2024 – Mar 2025',
    type: 'Trainee',
    description: 'Developed responsive SPAs and reusable React components, contributing to faster feature delivery and a significant reduction in reported bugs.',
    responsibilities: [
      'Developed 5+ responsive Single Page Applications using ReactJS, HTML5, CSS3, and JavaScript (ES6+)',
      'Built 15+ reusable React components, reducing code duplication by 35%',
      'Resolved 50+ bugs through systematic debugging, decreasing reported defects by 40%',
      'Built mobile-responsive, cross-browser compatible UI layouts using Bootstrap and CSS3',
      'Maintained clean Git history across shared repositories using Git and GitHub',
    ],
    tags: ['ReactJS', 'JavaScript', 'HTML5', 'CSS3', 'Bootstrap', 'Git'],
    isOpen: false,
  },
];

export default function Experience() {
  return (
    <section id="experience" className="relative py-16 md:py-24 overflow-hidden">
      <div className="glow-orb w-72 h-72 bg-violet-600 top-20 right-0" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 scroll-animate">

          <h2 className="section-title gradient-text">Work Experience</h2>
          <div className="title-line" />
        </div>

        <div className="relative">
          {/* Vertical line — left-aligned on all screens */}
          <div
            className="absolute left-4 sm:left-5 top-0 bottom-0 w-px"
            style={{ background: 'linear-gradient(to bottom, #7c3aed, #06b6d4, transparent)' }}
          />

          <div className="space-y-8">
            {experiences.map((exp, i) => (
              <div key={i} className="relative pl-12 sm:pl-14 scroll-animate">
                {/* Dot */}
                <div
                  className={`absolute left-4 sm:left-5 -translate-x-1/2 w-4 h-4 rounded-full border-2 bg-[#0a0a0f] z-10 ${exp.isOpen ? 'border-green-400' : 'border-violet-500'
                    }`}
                  style={{ top: '22px' }}
                />

                <div className={`glass-card p-4 sm:p-6 ${exp.isOpen ? 'border border-green-500/40' : ''}`}>
                  {/* Header */}
                  <div className="flex flex-wrap items-start justify-between gap-2 mb-3">
                    <div>
                      <div className="flex items-center gap-2">
                        {exp.isOpen && (
                          <span className="w-2.5 h-2.5 rounded-full bg-green-400 animate-pulse flex-shrink-0" />
                        )}
                        <h3 className={`text-base sm:text-lg font-bold ${exp.isOpen ? 'text-green-400' : 'text-white'}`}>
                          {exp.role}
                        </h3>
                      </div>
                      <div className="flex items-center gap-1 text-violet-400 font-semibold text-xs sm:text-sm mt-0.5">
                        <FaBriefcase size={11} /> {exp.company}
                      </div>
                    </div>
                    <span
                      className="text-xs px-3 py-1 rounded-full font-medium flex-shrink-0"
                      style={{
                        background: exp.isOpen ? 'rgba(34,197,94,0.15)' : 'rgba(124,58,237,0.2)',
                        border: exp.isOpen ? '1px solid rgba(34,197,94,0.4)' : '1px solid rgba(124,58,237,0.4)',
                        color: exp.isOpen ? '#4ade80' : '#a78bfa',
                      }}
                    >
                      {exp.type}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-3 text-xs text-slate-500 mb-3">
                    <span className="flex items-center gap-1"><FaCalendarAlt size={10} /> {exp.period}</span>
                    <span className="flex items-center gap-1"><FaMapMarkerAlt size={10} /> {exp.location}</span>
                  </div>

                  <p className="text-slate-400 text-sm mb-3">{exp.description}</p>

                  <ul className="space-y-1.5 mb-4">
                    {exp.responsibilities.map((r, j) => (
                      <li key={j} className="flex items-start gap-2 text-xs sm:text-sm text-slate-400">
                        <span className="text-violet-400 mt-0.5 flex-shrink-0">▹</span>
                        {r}
                      </li>
                    ))}
                  </ul>

                  <div className="flex flex-wrap gap-2">
                    {exp.tags.map(tag => (
                      <span key={tag} className="tag text-xs">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
